const Loading = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-black">
      <div class="space-x-2 flex">
        <h1
          style={{ animationDelay: "-0.25s" }}
          class="loading-text text-white"
        >
          Y
        </h1>
        <h1 style={{ animationDelay: "-0.5s" }} class="loading-text text-white">
          o
        </h1>
        <h1
          style={{ animationDelay: "-0.75s" }}
          class="loading-text text-white"
        >
          u
        </h1>
        <h1 style={{ animationDelay: "-1s" }} class="loading-text text-white">
          r
        </h1>

        <h1
          style={{ animationDelay: "-1s" }}
          class="loading-text text-blue-600"
        >
          C
        </h1>
        <h1
          style={{ animationDelay: "-0.75s" }}
          class="loading-text text-blue-600"
        >
          h
        </h1>
        <h1
          style={{ animationDelay: "-0.5s" }}
          class="loading-text  text-blue-600"
        >
          a
        </h1>
        <h1
          style={{ animationDelay: "-0.25s" }}
          class="loading-text text-blue-600"
        >
          t
        </h1>
        <h1
          style={{ animationDelay: "-0.25s" }}
          class="loading-text text-blue-600"
        >
          .
        </h1>
        <h1
          style={{ animationDelay: "-0.5s" }}
          class="loading-text text-blue-600"
        >
          .
        </h1>
        <h1
          style={{ animationDelay: "-0.75s" }}
          class="loading-text text-blue-600"
        >
          .
        </h1>
      </div>
    </div>
  );
};

export default Loading;
